import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'

const AnimatedText = ({ messageText, containerRef }) => {
  const [animatedContent, setAnimatedContent] = useState([])
  const wordRefs = useRef([])

  useEffect(() => {
    if (!messageText) return

    const wrapper = document.createElement('div')
    wrapper.innerHTML = messageText

    wordRefs.current = []

    let totalWordIndex = 0

    const processNode = node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.split(/\s+/).filter(Boolean)

        return words.map((word, i) => {
          const delay = totalWordIndex * 0.08
          const refIndex = totalWordIndex
          totalWordIndex++

          const wordRef = React.createRef()
          wordRefs.current[refIndex] = wordRef

          return (
            <motion.span
              ref={wordRef}
              key={`word-${refIndex}`}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.25,
                delay
              }}
              onAnimationComplete={() => {
                const el = wordRefs.current[refIndex]?.current
                const container = containerRef?.current
                const isAtBottom =
                  container.scrollHeight - container.scrollTop <
                  container.clientHeight + 250
                console.log('bottom', isAtBottom)
                if (el && container && isAtBottom) {
                  // el.scrollIntoView({ behavior: 'smooth', block: 'end' })
                  console.log('container ref', container.scrollHeight)
                  // If it's the last word, scroll fully to bottom
                  if (refIndex === wordRefs.current.length - 1) {
                    setTimeout(() => {
                      container.scrollTo({
                        top: container.scrollHeight,
                        behavior: 'smooth'
                      })
                    }, 200) // small delay so scrollIntoView doesn't cancel it
                  }
                } else {
                  console.log('not scrolling')
                }
              }}
              style={{ display: 'inline-block', marginRight: '4px' }}
            >
              {word}
            </motion.span>
          )
        })
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const Tag = node.tagName.toLowerCase()

        // Handle void tags that cannot have children
        if (Tag === 'br' || Tag === 'hr' || Tag === 'img' || Tag === 'input') {
          return React.createElement(Tag, { key: totalWordIndex })
        }

        const children = Array.from(node.childNodes).map(processNode).flat()

        return React.createElement(
          Tag,
          {
            key: totalWordIndex,
            style: {
              display: Tag === 'li' ? 'list-item' : '',
              marginBottom: '10px'
            }
          },
          children
        )
      }

      return null
    }

    const elements = Array.from(wrapper.childNodes).map(node =>
      processNode(node)
    )
    setAnimatedContent(elements)
  }, [messageText, containerRef])

  return (
    <div style={{ paddingRight: '40px', wordBreak: 'break-word' }}>
      {animatedContent}
    </div>
  )
}

export default AnimatedText
